export default "__VITE_ASSET__BQhhEk5w__"